// extracted by mini-css-extract-plugin
export default {"row":"CIDcWZ64BkcLuVITXak4"};